import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { trigger, animate, state, style, transition } from '@angular/animations';

import { first, filter } from 'rxjs/operators';
import { FirebaseService } from '../firebase.service';
import { ContentfulService } from '../contentful.service';
import * as en_stops from './stops';
import * as es_stops from './stops.es';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  animations: [
    trigger('arrivedTrigger', [
      state('true', style({ "background-position-x": "100%", color: "white"})),
      state('false', style({ "background-position-x": "0%", color: "#ACA8A8" })),
      transition('true <=> false', animate('.5s ease'))
    ]),
    trigger('infoAnimate', [
      transition(':leave', [
        style({'max-height': "1000vh", height: "600vh"}),
        animate('1s ease', style({'max-height': '0px', height: "0"}))
      ])
    ]),
    trigger('arrived', [
      transition(':leave', [
        animate('.8s ease', style({ transform: 'translateY(-150%)' }))
      ])
    ]),
    trigger('finished', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('.2s ease', style({ opacity: 1 }))
      ])
    ])
  ],
  styleUrls: ['./tour.component.scss']
})
export class TourComponent implements OnInit {

  next_stops: any;
  banner: any;
  infos: any;
  info1: any;
  fetchLocation:boolean = true
  narrations: any;
  slugs: any;

  @HostListener('window:scroll', ['$event'])
    scrollHandler(event) {
      const ratio = window.innerHeight*.16;
      if (window.scrollY+window.innerHeight >= window.document.body.scrollHeight - 50) {
        this.overflowHidden = true;
        this.audioHidden = true;
      } else {
        this.overflowHidden = false;
        this.audioHidden = false;
      }
    }

  language: string = "en";

  displayMenu: boolean = false;
  displayHelp: boolean = false;
  displayHelpTimer: any;
  displayHelpBtn: boolean = false; // Used to help user after 40 seconds of not getting to first stop
  overflowHidden: boolean = false; // Used to detect when to set overflow-hidden to info container
  audioHidden: boolean = false; //Display audio component in info view
  // begin: boolean = true;

  data_num: number = 1;
  stops: Array<any> = [];
  current_stop: number = -1;
  next_stop: number = 0;
  arrived: boolean = false;
  at_stop: boolean = false;
  state: string = "begin";
  stopNumber: number = 0;
  testing: boolean = false;
  instruction: boolean = true;
  stopData: any = {
    banner: {
      alt: "",
      url: ""
    },
    intro: "",
    name: "",
    slug: "",
    info: []
  };
  isProduction: boolean = environment.production;


  continueBtnAriaLabel: string = "Continue to Sonoma City Hall info";

  constructor(
    private fs: FirebaseService,
    private router: Router,
    private contentful: ContentfulService,
    private activeRoute: ActivatedRoute
  ) {
    let isSpanish = router.url.slice(0, 4) == "/es" || router.url.slice(0, 4) == "/es/";
    if (isSpanish) { //Spanish Tour
      this.language = "es";
      this.next_stops = es_stops.NEXT_STOPS;
      this.banner = es_stops.BANNER;
      this.infos = es_stops.INFOS;
      this.info1 = es_stops.INFO1;
      this.narrations = es_stops.NARRATIONS;
      this.slugs = es_stops.SLUGS;
    } else { //English Tour
      this.next_stops = en_stops.NEXT_STOPS;
      this.banner = en_stops.BANNER;
      this.infos = en_stops.INFOS;
      this.info1 = en_stops.INFO1;
      this.narrations = en_stops.NARRATIONS;
      this.slugs = en_stops.SLUGS;
    }
    contentful.getStop(this.stopNumber).then(res => {
      this.stopData = res;
    });
    router.events.pipe(
      filter(
        ( event: NavigationEnd ) => {
          return ( event instanceof NavigationEnd );
        }
      )
    ).subscribe(event => {
      // if (this.rout)
      let fragment = this.router.parseUrl(this.router.url).fragment;
      if (this.state != "finished" && fragment != "iOSInstructions") {
        const curSlug = event.url.slice(1);
        console.log('curSlug', curSlug);
        if (curSlug.slice(-5) == "/info") {
          this.hasArrived(true);
          this.state = "info";
          if (this.state != "info") { //State is not info
            this.router.navigate([curSlug.slice(0, -5)]);
          } else {
            if (this.slugs[this.stopNumber] != curSlug.slice(0, -5) && this.slugs[this.stopNumber] != curSlug.slice(3, -5)) { //State is info, but wrong stop
              this.router.navigate([curSlug.slice(0, -5)]);
            }
          }
        }
        else {
          if (curSlug != this.slugs[this.stopNumber]) { //If user navigates to an insequential stop
            this.state = "continue";
            this.hasArrived(false);
            for (let i=0; i<this.slugs.length; i++) {
              if (this.slugs[i] == curSlug) {
                this.next_stop = i;
                console.log('i', i);
                this.stopNumber = i - 1;
                setTimeout(() => {
                  this.stopNumber = i;
                }, 5000);
                this.current_stop = i-1;
                console.log('set stop numbers', i, this.slugs[i], curSlug);
                break;
              }
            }
          } else {
            if (this.state == "info") {
              this.state = "arrived";
            }
          }
        }
      }
    });
    // const cur_slug = router.url.slice(1);
    // const cur_stop_name = router.url.includes('info') ? router.url.slice(1, -5) : cur_slug;
    // console.log('cur_slug', cur_slug, cur_stop_name);
    // const infoFragment = cur_slug.slice(-5) == "#info";
    // if (infoFragment) {
    //   this.router.navigate([cur_slug.slice(0,-5)]);
    // } else {
    //   for (let i=0; i<this.slugs.length; i++) {
    //     if (this.slugs[i] == cur_stop_name || "es/" + this.slugs[i] == cur_stop_name) {
    //       this.stopNumber = i;
    //       this.next_stop = i;
    //       console.log('set from constructor', i, this.slugs[i], cur_slug);
    //       break;
    //     }
    //     if (i == this.slugs.length-1) {
    //       this.router.navigate([this.slugs[0]]);
    //     }
    //   }
    // }
  }

  points: string = "points";

  ngOnInit(): void {
    if (this.router.url == "/test") {
      console.log("TEST POINTS");
      this.points = "test-points";
      this.testing = true;
    }
    this.fs.getAllPoints(this.points)
        .pipe(first())
        .subscribe(data => {
          data.forEach(docSnap => {
            this.stops.push(docSnap.data());
          });
        });
    setTimeout(() => {
    }, 2000)
    this.displayHelpTimer = setTimeout(() => {
      this.displayHelpBtn = true;
    }, 2000);
  }

  // location = (data) => {
  //   if(this.data_num == 1) {
  //     this.data1 = data;
  //   }
  //   else {
  //     this.data2 = data;
  //   }
  // }

  hasArrived(value: boolean) {
    clearTimeout(this.displayHelpTimer);
    this.displayHelp = false;
    this.displayHelpBtn = false;
    if (value != this.arrived) {
      this.arrived = value;
      if (this.arrived) {
        this.state = "arrived";
        this.current_stop = this.next_stop;
      }
    }
  }

  nextStop() {
    this.at_stop = false;
    this.arrived = false;
    this.next_stop++;
  }

  toggleHelp(val: boolean) {
    this.displayHelp = val;
  }

  toggleMenu(val: boolean) {
    this.displayMenu = val;
  }

  changeState() {
    if (this.state == "info") {
      if (this.stopNumber == 4) {
        this.state = "finished";
        this.router.navigate(["finished"]);
      } else {
        this.state = "continue";
        this.next_stop++;
        this.stopNumber++;
        // this.stopData = this.contentful.getStop(this.stopNumber);
        this.arrived = false;
        this.continueBtnAriaLabel = "Continue to " + this.next_stops[this.current_stop] + " tour info";
        if (this.language == "es") {
          this.router.navigate([this.slugs[this.next_stop]]);
        } else {
          this.router.navigate([this.slugs[this.next_stop]]);
        }
        this.displayHelpTimer = setTimeout(() => {
          this.displayHelpBtn = true;
        }, 2000);
      }
    } else if (this.state == "arrived") {
      this.state = "info";
      this.router.navigate([this.router.url + "/info"]);
      this.overflowHidden = false;
      if (this.stopNumber == 2) {
        this.continueBtnAriaLabel = "Finish tour";
      } else {
        this.continueBtnAriaLabel = "Continue to next tour stop"
      }
    }
    console.log("this.state", this.state);
  }

  instructionOff(val: boolean) {
    this.instruction = val;
  }

  changeStateFromInfo(val: boolean) {
    this.changeState();
  }

  fetchUserLocation(event){
    this.fetchLocation = event
  }
}
